export { default } from './Curriculum'
